import React from 'react'
import PropTypes from 'prop-types'

import { GroupedAccordion } from 'components/Shared/Accordion'
import { Field } from 'redux-form'
import ToggleField from 'components/Shared/Forms/ToggleField'
import { useSelector } from 'react-redux'
import { isCurrentUserAdaloAdmin } from '../../../ducks/users'

const NewReactNativeSwitch = ({
  useNewRNVersion,
  useNewArchitecture,
  formName,
}) => {
  const isAdaloAdmin = useSelector(isCurrentUserAdaloAdmin)

  const renderChildren = () => {
    return (
      <div>
        <div className="settings-form-row-troubleshoot">
          <span>
            We recently upgraded our platform to a newer version of React
            Native. While this brings improvements, some libraries may not yet
            support the new architecture or version. If you're experiencing
            build issues, try switching to the legacy version using the React
            Native Version toggle in your app settings.
          </span>
        </div>

        <div className="settings-form-row-with-margin">
          <Field
            name="useNewRNVersion"
            label="Use new React Native Version"
            component={ToggleField}
            inputValue={useNewRNVersion ? 'On' : 'Off'}
            tooltip="Switch to the latest React Native version. May improve performance but could cause compatibility issues with some libraries."
          />
          {useNewRNVersion && isAdaloAdmin && (
            <div className="settings-form-row-with-margin">
              <Field
                name="useNewArchitecture"
                label="Enable New Architecture"
                component={ToggleField}
                inputValue={useNewArchitecture ? 'On' : 'Off'}
                tooltip="Enable React Native's new architecture (Fabric & TurboModules). Use only if you're sure your dependencies are compatible."
              />
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <GroupedAccordion
      color={'coral'}
      className="app-settings-permissions"
      title="Trouble with React Native?"
      renderChildren={renderChildren}
      group="reactNativeVersion"
      itemId="reactNativeVersion"
      boxed
      hideDone
    />
  )
}

NewReactNativeSwitch.propTypes = {
  useNewRNVersion: PropTypes.bool.isRequired,
  useNewArchitecture: PropTypes.bool.isRequired,
}

export default React.memo(NewReactNativeSwitch)
